<template>
	<div class="page-qa-detail">
		<div class="header">
			<img :src="ossPondHost + 'img/xiazeng_icon.png'" />
			<div class="header-num">虾罾编号 <span>{{ info.uniqueId }}</span></div>
			<div class="header-num">imei <span>{{ info.imei ? info.imei : '--' }}</span></div>
			<div class="header-num">iccid <span>{{ info.iccid ? info.iccid : '--' }}</span></div>
		</div>

		<div class="body">
			<div class="item">
				<div class="item-label">匹配编号，下发配置</div>
				<div class="item-value">已完成</div>
			</div>
			<div class="item">
				<div class="item-label">远程打样测试</div>
				<div class="item-value">
					<span v-if="info.testSample == 1" class="view-media" @click="openMediaModal">查看视频和照片</span>
					<span v-else>未完成</span>
				</div>
			</div>
			<div class="item">
				<div class="item-label">手动按键测试</div>
				<div class="item-value">{{ info.testBtn == 1 ? '已完成' : '未完成' }}</div>
			</div>
			<div class="item">
				<div class="item-label">信号强度测试</div>
				<div class="item-value">{{ info.signalQualified == 1 ? '已完成' : '未完成' }}</div>
			</div>
			<div class="item">
				<div class="item-label">操作人</div>
				<div class="item-value">{{ info.operationName }}</div>
			</div>
			<div class="item">
				<div class="item-label">提交时间</div>
				<div class="item-value on">
					<div>{{ info.submitDate }}</div>
					<div>{{ info.submitHour }}</div>
				</div>
			</div>
		</div>

		<!-- 远程打样测试 视频照片弹框 -->
		<div v-if="showMediaModal" class="media-modal" @touchmove.prevent>
			<div class="media-box">
				<video
					v-if="currentIndex === 0 && videoUrl"
					ref="mediaVideo"
					controls
					playsinline
					webkit-playsinline
					:src="videoUrl"
					:poster="picUrl"
				></video>
				<img v-else :src="picUrl" @click="showPreviewImg = true" />
			</div>
			<div v-if="picUrl" class="media-list">
				<div
					class="item"
					:class="{ active: currentIndex === 0 }"
					@click="changeMediaIndex(0)"
				>
					<div class="img-box">
						<img :src="picUrl" />
						<div class="play-icon"></div>
					</div>
				</div>
				<div
					class="item"
					:class="{ active: currentIndex === 1 }"
					@click="changeMediaIndex(1)"
				>
					<div class="img-box">
						<img :src="picUrl" />
					</div>
				</div>
			</div>
			<div v-else class="media-empty">未获取到视频和照片</div>
			<img
				class="close-btn"
				src="https://static.yudada.com/wechat/pond/img/icon_close_modal.png"
				@click="closeMediaModal"
			/>
			<div v-if="showPreviewImg" class="preview-mask" @click="showPreviewImg = false">
				<img :src="picUrl" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'XiazengQaDetail',
	data() {
		const { ossHostPond } = this.$config.base;
		return {
			ossPondHost: ossHostPond,
			info: {},
			showMediaModal: false,
			showPreviewImg: false,
			currentIndex: 0,
			picUrl: '',
			videoUrl: '',
		};
	},
	created() {
		const vm = this;
		// 从路由 query 获取详情数据（JSON 字符串）
		const infoStr = vm.$route.query.info;
		if (infoStr) {
			try {
				const info = JSON.parse(infoStr);
				if (info && info.submitTime) {
					const parts = info.submitTime.split(' ');
					info.submitDate = parts[0] || '';
					info.submitHour = parts[1] || '';
				}
				vm.info = info;
				vm.picUrl = vm.getUrl(info.testPic);
				vm.videoUrl = vm.getUrl(info.testVideo);
			} catch (e) {
				vm.info = {};
			}
		}
	},
	methods: {
		// testPic/testVideo 兼容字符串或数组格式，取第一个有效值
		getUrl(val) {
			if (!val) return '';
			if (Array.isArray(val)) {
				return val.find((item) => !!item) || '';
			}
			return val;
		},
		openMediaModal() {
			this.showMediaModal = true;
			this.showPreviewImg = false;
			this.currentIndex = 0;
		},
		closeMediaModal() {
			this.showMediaModal = false;
			this.showPreviewImg = false;
			const video = this.$refs.mediaVideo;
			if (video) {
				video.pause();
			}
		},
		changeMediaIndex(index) {
			this.currentIndex = index;
		},
	},
};
</script>

<style lang="less" scoped>
@import '@/less/base.less';

.page-qa-detail {
	min-height: 100vh;
	background: @bgColor2;
	padding: 0.2rem 0.1rem;
	box-sizing: border-box;
	font-size: 0.16rem;
	color: @textColor1;
	letter-spacing: 1px;

	.header {
		position: relative;
		padding-left: 0.9rem;
		font-size: 0.2rem;
		display: flex;
		flex-direction: column;
		justify-content: center;

		img {
			width: 0.7rem;
			height: 0.7rem;
			position: absolute;
			left: 0.1rem;
			top: 0.1rem;
		}

		&-num {
			padding-top: 0.1rem;
			display: flex;
			align-items: baseline;

			span {
				flex: 1;
				min-width: 0;
				font-weight: bold;
				color: @textColor12;
				margin-left: 0.1rem;
				word-break: break-all;
				text-align: right;
			}
		}
	}

	.body {
		margin-top: 0.2rem;
		background: @blank;
		border-radius: 0.05rem;
		box-shadow: 0px 0px 6px 4px rgba(0, 0, 0, 0.05);
		line-height: 0.7rem;

		.item {
			display: flex;
			justify-content: space-between;
			padding: 0 0.15rem;
			box-sizing: border-box;
			flex-wrap: wrap;

			&-value {
				color: @textColor12;
				font-weight: bold;
				width: 1.3rem;
				text-align: right;
				word-break: break-all;

				&.on {
					line-height: 0.35rem;
				}
			}
		}
	}

	.view-media {
		color: @themeColor;
		font-weight: bold;
		cursor: pointer;
	}

	.media-modal {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.8);
		z-index: 99;
		color: @blank;
		padding: 0.3rem 0.1rem;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: center;

		.media-box {
			width: 100%;
			height: 2.25rem;
			display: flex;
			justify-content: center;
			align-items: center;
			overflow: hidden;

			video,
			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}

		.media-list {
			margin-top: 0.37rem;
			display: flex;

			.item {
				height: 0.75rem;
				width: 0.75rem;
				margin-right: 0.1rem;
				border-radius: 0.05rem;

				.img-box {
					position: relative;
					height: 0.75rem;
					width: 0.75rem;
					border: 0.02rem solid #313232;
					border-radius: 0.05rem;
					box-sizing: border-box;
					display: flex;
					justify-content: center;
					align-items: center;
					overflow: hidden;

					img {
						height: 100%;
						width: 100%;
						border-radius: 0.05rem;
					}

					.play-icon {
						position: absolute;
						left: 50%;
						top: 50%;
						transform: translate(-50%, -50%);
						width: 0;
						height: 0;
						border-left: 0.1rem solid rgba(255, 255, 255, 0.9);
						border-top: 0.07rem solid transparent;
						border-bottom: 0.07rem solid transparent;
					}
				}

				&.active {
					.img-box {
						border-color: @themeColor;
					}
				}
			}
		}

		.media-empty {
			margin-top: 0.37rem;
			text-align: center;
			color: @blank;
		}

		.close-btn {
			position: fixed;
			left: 50%;
			bottom: 0.6rem;
			transform: translateX(-50%);
			width: 0.5rem;
			height: 0.5rem;
		}

		.preview-mask {
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: rgba(0, 0, 0, 0.9);
			z-index: 100;
			display: flex;
			justify-content: center;
			align-items: center;

			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}
	}
}
</style>
